import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';

import { MatTabNav, MatTabLink, MatTabNavPanel } from '@angular/material/tabs';
import { RouterLink } from '@angular/router';
import { RootState } from '@next/core-lib/app';
import { TranslatePipe } from '@next/core-lib/i18n';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { Cycle } from '../../../cycle/models/cycle.model';
import { getCycles } from '../../../cycle/store/selectors/cycle.selectors';

@Component({
  selector: 'app-report-navigation',
  templateUrl: 'report-navigation.component.html',
  imports: [MatTabNav, MatTabLink, RouterLink, MatTabNavPanel, AsyncPipe, TranslatePipe],
})
export class ReportNavigationComponent {
  private readonly store = inject<Store<RootState>>(Store);

  cycles$: Observable<Cycle[]> = this.store.select(getCycles);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}
}
